import { TextField, TextArea } from '@cimpress/react-components';
import styles from '../css/pages.module.scss';
import type { GeneralTabFormData } from '../models/EditableList';
import TagInput from './shared/TagInput';

interface GeneralTabProps {
  formData: GeneralTabFormData;
  onChange: (data: GeneralTabFormData) => void;
}

const GeneralTab = ({ formData, onChange }: GeneralTabProps) => {
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...formData, entityTypeName: e.target.value });
  };

  const handleTagsChange = (tags: string[]) => {
    onChange({ ...formData, tags });
  };

  const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    onChange({ ...formData, description: e.target.value });
  };

  return (
    <div className={styles.generalTabContainer}>
      <TextField
        label="Name"
        value={formData.entityTypeName}
        onChange={handleNameChange}
        required
      />
      <TagInput
        label="Tags"
        value={formData.tags}
        onChange={handleTagsChange}
      />
      <TextArea
        label="Description"
        required
        value={formData.description}
        onChange={handleDescriptionChange}
        rows={4}
      />
    </div>
  );
};

export default GeneralTab;
